var consumer = {
  "units": {
    "Wh": {
      "single": "wattuur",
      "plural": "wattuur",
      "annotated_abv": "(Wh)",
      "abv": "Wh",
      "definition": "Energieproductie en -verbruik wordt gemeten in wattuur (Wh). Een kilowattuur is gelijk aan 1000 wattuur en deze eenheid wordt over het algemeen door elektriciteitsleveranciers gebruikt op de maandafrekening."
    },
    "kWh": {
      "single": "kilowattuur",
      "plural": "kilowattuur",
      "annotated_abv": "(kWh)",
      "abv": "kWh"
    },
    "MWh": {
      "single": "megawattuur",
      "plural": "megawattuur",
      "annotated_abv": "(MWh)",
      "abv": "MWh"
    },
    "GWh": {
      "single": "gigawattuur",
      "plural": "gigawattuur",
      "annotated_abv": "(GWh)",
      "abv": "GWh"
    },
    "TWh": {
      "single": "terawattuur",
      "plural": "terawattuur",
      "annotated_abv": "(TWh)",
      "abv": "TWh"
    },
    "PWh": {
      "single": "petawattuur",
      "plural": "petawattuur",
      "annotated_abv": "(PWh)",
      "abv": "PWh"
    },
    "EWh": {
      "single": "exawattuur",
      "plural": "exawattuur",
      "annotated_abv": "(EWh)",
      "abv": "EWh"
    },
    "ZWh": {
      "single": "zettawattuur",
      "plural": "zettawattuur",
      "annotated_abv": "(ZWh)",
      "abv": "ZWh"
    },
    "YWh": {
      "single": "yottawattuur",
      "plural": "yottawattuur",
      "annotated_abv": "(YWh)",
      "abv": "YWh"
    },
    "W": {
      "single": "watt",
      "plural": "watt",
      "annotated_abv": "(W)",
      "abv": "W"
    },
    "kW": {
      "single": "kilowatt",
      "plural": "kilowatt",
      "annotated_abv": "(kW)",
      "abv": "kW"
    },
    "MW": {
      "single": "megawatt",
      "plural": "megawatt",
      "annotated_abv": "(MW)",
      "abv": "MW"
    },
    "GW": {
      "single": "gigawatt",
      "plural": "gigawatt",
      "annotated_abv": "(GW)",
      "abv": "GW"
    },
    "TW": {
      "single": "terawatt",
      "plural": "terawatt",
      "annotated_abv": "(TW)",
      "abv": "TW"
    },
    "PW": {
      "single": "petawatt",
      "plural": "petawatt",
      "annotated_abv": "(PW)",
      "abv": "PW"
    },
    "EW": {
      "single": "exawatt",
      "plural": "exawatt",
      "annotated_abv": "(EW)",
      "abv": "EW"
    },
    "ZW": {
      "single": "zettawatt",
      "plural": "zettawatt",
      "annotated_abv": "(ZW)",
      "abv": "ZW"
    },
    "YW": {
      "single": "yottawatt",
      "plural": "yottawatts",
      "annotated_abv": "(YW)",
      "abv": "YW"
    },
    "percent": {
      "single": "procent",
      "plural": "procent",
      "annotated_abv": "%",
      "abv": "%"
    },
    "minutes": {
      "zero": "minuten",
      "ltone": "minuut",
      "single": "minuut",
      "plural": "minuten"
    },
    "hours": {
      "zero": "uur",
      "ltone": "uur",
      "single": "uur",
      "plural": "uur"
    },
    "months": {
      "zero": "maanden",
      "ltone": "maand",
      "single": "maand",
      "plural": "maanden"
    },
    "years": {
      "zero": "jaren",
      "ltone": "jaar",
      "single": "jaar",
      "plural": "jaren"
    },
    "days": {
      "zero": "dagen",
      "ltone": "dag",
      "single": "dag",
      "plural": "dagen"
    },
    "nights": {
      "zero": "nachten",
      "ltone": "nacht",
      "single": "nacht",
      "plural": "nachten"
    },
    "batteries": {
      "zero": "batterijen",
      "ltone": "batterij",
      "single": "batterij",
      "plural": "batterijen"
    },
    "trees": {
      "zero": "bomen",
      "ltone": "boom",
      "single": "boom",
      "plural": "bomen"
    },
    "kg": {
      "zero": "kg",
      "ltone": "kg",
      "single": "kg",
      "plural": "kgs"
    },
    "laps": {
      "zero": "ronden",
      "ltone": "ronde",
      "single": "ronde",
      "plural": "ronden"
    },
    "barrels": {
      "zero": "vaten",
      "ltone": "vat",
      "single": "vat",
      "plural": "vaten"
    },
    "flights": {
      "zero": "vluchten",
      "ltone": "vlucht",
      "single": "vlucht",
      "plural": "vluchten"
    },
    "launches": {
      "zero": "lanceringen",
      "ltone": "lancering",
      "single": "lancering",
      "plural": "lanceringen"
    }
  },
  "timeAgo": {
    "now": "Nu",
    "second": {
      "single": "1 seconde geleden",
      "plural": "%{number} seconden geleden"
    },
    "minute": {
      "single": "1 minuut geleden",
      "plural": "%{number} minuten geleden"
    },
    "hour": {
      "single": "1 uur geleden",
      "plural": "%{number} uur geleden"
    },
    "day": {
      "single": "1 dag geleden",
      "plural": "%{number} dagen geleden"
    },
    "week": {
      "single": "1 week geleden",
      "plural": "%{number} weken geleden"
    },
    "month": {
      "single": "1 maand geleden",
      "plural": "%{number} maanden geleden"
    },
    "year": {
      "single": "1 jaar geleden",
      "plural": "%{number} jaar geleden"
    }
  },
  "weather": {
    "unknown": "Weer onbekend",
    "footer": "Weergegevens verstrekt door The Weather Company.",
    "credit": "Verstrekt door The Weather Company."
  },
  "reports": {
    "title": "Rapporten",
    "submit": "Rapport uitvoeren",
    "to": "tot",
    "selectDate": "Select the date",
    "insufficientData": "Kom morgen terug. Enphase cloud heeft niet de benodigde gegevens verzameld om rapporten te maken.",
    "1": {
      "name": "Dagelijkse productie",
      "title": "Energieproductie van locatie",
      "description": "Overzicht van de dagelijkse energieproductie van deze locatie. Dit rapport bevat de energie per dag, daarom kunt u dagen opvragen tot en met gisteren."
    },
    "2": {
      "name": "Recente productie",
      "title": "Recente stroomproductie van locatie",
      "description": "Overzicht van de stroomproductie van deze locatie in de afgelopen week, weergegeven in stappen van 5 minuten."
    },
    "6": {
      "name": "Maandelijkse productie",
      "title": "Maandelijkse energieproductie",
      "description": "Overzicht van een maand energieproductie en piekvermogen van deze locatie."
    },
    "15": {
      "name": "Dagelijks verbruik",
      "title": "Energieverbruik van locatie",
      "description": "Overzicht van het dagelijkse energieverbruik van deze locatie. Dit rapport bevat de energie per dag, daarom kunt u dagen opvragen tot en met gisteren."
    },
    "16": {
      "name": "Recente energieverbruik",
      "title": "Recente energieverbruik van locatie",
      "description": "Overzicht van de stroomproductie van deze locatie in de afgelopen week, weergegeven in stappen van 15 minuten."
    },
    "17": {
      "name": "Netto-energie per maand",
      "title": "Netto-energie per maand",
      "description": "In dit rapport wordt de energie die is geproduceerd, verbruikt, geïmporteerd naar en geëxporteerd van de locatie, weergegeven voor elke vijftien minuten van de geselecteerde maand. Als het systeem AC-batterijen bevat, worden in het rapport ook de opgeslagen en ontlade energie weergegeven."
    },
    "19": {
      "name": "Batterijrapport",
      "title": "Batterijrapport",
      "description": "Dit rapport toont de gegevens van de laatste 7 dagen van de batterij"
    },
    "3": {
      "name": "Energieproductie van één dag per module",
      "title": "Energieproductie van één dag per module",
      "description": "Dit rapport bevat de energieproductie van alle micro-omvormers op de gespecificeerde datum."
    },
    "5": {
      "name": "Energieproductie van één maand per module",
      "title": "Energieproductie van één maand per module",
      "description": "Dit rapport bevat de energieproductie van alle micro-omvormers voor de gespecificeerde maand."
    },
    "20": {
      "name": "IQ-Relay zelftestrapport",
      "title": "IQ-Relay zelftestresultatenrapport",
      "description": "Dit rapport verstrekt de laatste IQ-Relay zelftestresultaten"
    },
    "25": {
      "name": "Aangepast rapport (in Wh)",
      "title": "Aangepast rapport",
      "description": ""
    }
  },
  "stats": {
    "total": "Totaal energie",
    "peak_production": "Piekvermogen",
    "latest_production": "Meest recente vermogen",
    "peak_consumption": "Piekverbruik",
    "latest_consumption": "Meest recent verbruik",
    "recent_power": "Recente stroom",
    "maintainer": "Neem contact op met uw onderhoudsmonteur",
    "enphase": "Neem contact op met Enphase-ondersteuning",
    "orenphase": "Of neem contact op met Enphase-ondersteuning",
    "learn_more": "Meer informatie.",
    "where": "Waar zit het probleem?",
    "toGrid": "Ongeveer %{value} geëxporteerd naar lichtnet",
    "fromGrid": "Ongeveer %{value} geïmporteerd van lichtnet",
    "normal": {
      "title": "Normaal",
      "modal": "Uw systeem functioneert normaal."
    },
    "shortcomm": {
      "title": "Gateway rapporteert niet",
      "hours": "Uw systeem heeft geen gegevens gemeld aan de Enphase cloud voor de afgelopen %{hours} uur.",
      "date": "Uw systeem heeft sinds %{date} geen gegevens gemeld aan de Enphase cloud.",
      "unknown": "Dit systeem meldt niet aan de Enphase cloud.",
      "question": "Is uw internetverbinding weggevallen?",
      "help_topic_link": "Maak opnieuw verbinding om de prestaties van uw systeem te bekijken",
      "link": "Klik hier voor hulp."
    },
    "meter": {
      "title": "Meter rapporteert niet",
      "hours": "De meter van dit systeem heeft gedurende de laatste %{hours} uur geen gegevens gerapporteerd aan de Gateway.",
      "date": "De meter van dit systeem heeft geen gegevens gerapporteerd aan de Gateway sinds %{date}.",
      "ct_wiring": "Er is een probleem met de metingen van de meter van uw Gateway. Neem contact op met uw onderhoudsmonteur voor hulp.",
      "unknown": "De meter van uw systeem rapporteert niet aan de Gateway.",
      "link": "Klik hier voor hulp.",
      "modal": "Uw meter heeft geen gegevens gerapporteerd aan de Gateway sinds"
    },
    "meter_issue": {
      "title": "Probleem met meter",
      "ct_wiring": "Er is een probleem met de meetwaarden van uw Envoy-meter",
      "link": "Klik hier voor hulp."
    },
    "battery": {
      "title": "AC-batterijen rapporteren niet",
      "modal": "Deze AC-batterij rapporteert geen gegevens.",
      "message": "Sommige AC-batterijen rapporteren geen gegevens.",
      "messageSome": "Sommige AC-batterijen (%{count}) rapporteren geen gegevens.",
      "link": "Klik hier voor hulp."
    },
    "storage_idle": {
      "title": "Opslag niet actief",
      "modal": "Deze AC-batterij laadt niet op of ontlaadt niet.",
      "date": "Ten minste één AC-batterij is niet opgeladen of ontladen sinds %{date}.",
      "unknown": "Ten minste één AC-batterij laadt niet op of ontlaadt niet.",
      "link": "Klik hier voor hulp."
    },
    "encharge": {
      "title": "Batterij rapporteert niet",
      "modal": "De batterij rapporteert geen gegevens.",
      "message": "Batterij rapporteert geen gegevens. Dit probleem kan zich voordoen als de draadloze communicatie tussen uw gateway en batterij zwak is. Dit is mogelijk een tijdelijk probleem dat snel wordt hersteld.",
      "requestMaintainer": "Neem contact op met uw onderhoudsmonteur voor hulp als het probleem zich blijft voordoen.",
      "messageSome": "Sommige batterijen (%{count}) rapporteren geen gegevens.",
      "link": "Klik hier voor hulp."
    },
    "enpower": {
      "title": "Systeemcontroller rapporteert niet",
      "modal": "Deze systeemcontroller rapporteert geen gegevens.",
      "message": "SSysteemcontroller rapporteert geen gegevens. Dit probleem kan zich voordoen als de draadloze communicatie tussen uw gateway en systeemcontroller zwak is. Dit is mogelijk een tijdelijk probleem dat snel wordt hersteld.",
      "requestMaintainer": "Neem contact op met uw onderhoudsmonteur voor hulp als het probleem zich blijft voordoen.",
      "messageSome": "Sommige systeemcontrollers (%{count}) rapporteren geen gegevens.",
      "link": "Klik hier voor hulp."
    },
    "encharge_issue": {
      "title": "Batterijstoring",
      "modal": "Deze batterij heeft een storing.",
      "message": "Batterij heeft een storing."
    },
    "enpower_issue": {
      "title": "Storing in de systeemcontroller",
      "modal": "Deze systeemcontroller heeft een storing.",
      "message": "Systeemcontroller heeft een storing."
    },
    "micro": {
      "title": "Micro-omvormers rapporteren niet",
      "modal": "Deze micro-omvormer rapporteert geen gegevens aan de Gateway.",
      "message": "Sommige micro-omvormers rapporteren geen gegevens aan de Gateway.",
      "messageSome": "Sommige micro-omvormers (%{count}) rapporteren geen gegevens aan de Gateway.",
      "messageAll": "Geen enkele micro-omvormer rapporteert gegevens aan de Gateway.",
      "link": "Klik hier voor hulp."
    },
    "power": {
      "title": "Systeemproductiestoring",
      "message": "Er is een productiestoring opgetreden in uw systeem.",
      "messageSome": "Deze micro-omvormer rapporteert een productiestoring.",
      "messageThreshold": "Uw systeem produceert minder energie dan verwacht.",
      "link": "Neem contact op met Enphase-ondersteuning voor hulp.",
      "maintainerlink": "Neem contact op met uw onderhoudsmonteur voor hulp."
    }
  }
};
module.exports = consumer;